import { lazy } from 'react';

const LogoutPage = lazy(() => import('./pages/LogoutPage'));

export const LogoutEntry = () => <LogoutPage />;
